import React from 'react';
import FaceSwapHeader from './FaceSwapHeader';
import FaceSwapMain from './FaceSwapMain';
import Footer from './Footer';
// import FaceSwapHistoryDebugger from './FaceSwapHistoryDebugger';
import './FaceSwapPage.css';

const FaceSwapPage: React.FC = () => {
  // 检测是否在开发环境或者有调试参数
  const showDebugger = process.env.NODE_ENV === 'development' || 
                       window.location.search.includes('debug=true');

  return (
    <div className="face-swap-page">
      {/* Header */}
      <FaceSwapHeader />
      
      {/* Main Content */}
      <FaceSwapMain />
      
      {/* Footer */}
      <Footer />
      
      {/* Debugger - Only shown in development environment or when ?debug=true is added */}
      {/* {showDebugger && <FaceSwapHistoryDebugger />} */}
    </div>
  );
};

export default FaceSwapPage;